export const AgentCustomerSales = {
    "sections": [
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "combo",
          "colorTheme": "colorTheme2",
          "title": "Peso Sales and Number of Customers/Branches",
          "orientation": "vertical",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
                {
                  "name": 'Actual Sales',
                  "value": 'ActualSales(Value)',
                  "type": 'column'
  
                },
                {
                  "name": 'Number of Accounts',
                  "value": 'NumberOfAccounts',
                  "type": 'line'
                }
              ],
              "title": 'CustomerGroup',
              "endpoint": "T19.4",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "AgentCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "CustomerGroup",
                  "selectedTitle": "Channel",
                  "visual": [
                    {
                      "columns": 12,
                      "rows": 2,
                      "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": "colorTheme1",
                        "title": "Channel",
                        "binding": {
                          "data": {
                            "columns": [
                              {
                                "name": 'Channel',
                                "columnName": 'DistributorCode',
                                "width": '180px',
                                "align": "left",
                                "sortable": true,
                                "sum": false
                              },
                              {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales(Value)',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true
                              },
                              {
                                "name": 'LY Sales',
                                "columnName": 'LYSales(Value)',
                                "width": '135px',
                                "align": "right",
                                "sortable": true,
                                "sum": true
                              },
                              {
                                "name": 'Growth %',
                                "columnName": 'Growth(Value)',
                                "width": '135px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                              }
                            ],
                            "title": 'DistributorCode',
                            "endpoint": "T19.1",
                            "parameters": [
                              { "key": "FromMonth", "value": "2024" },
                              { "key": "FromYear", "value": "1" },
                              { "key": "ToMonth", "value": "2024" },
                              { "key": "ToYear", "value": "1" },
                              { "key": "AgentCode", "value": "" },
                              { "key": "CustomerGroup", "value": "" },
                              { "key": "ConfigTypeCode", "value": "" }
                            ]
                          },
                          "context": {
                            "point": {
                              "onClick": {
                                "selectedValueColumn": "CustomerGroupDistributorCode",
                                "selectedTitle": "Customer",
                                "visual": [
                                  {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                      "id": 1,
                                      "type": "advancedTable",
                                      "colorTheme": "colorTheme1",
                                      "title": "Customer",
                                      "binding": {
                                        "data": {
                                          "columns": [
                                            {
                                              "name": 'Customer Name',
                                              "columnName": 'CustomerName',
                                              "width": '250px',
                                              "align": "left",
                                              "sortable": true,
                                              "sum": false
                                            },
                                            {
                                              "name": 'Actual Sales',
                                              "columnName": 'ActualSales(Value)',
                                              "width": '140px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true
                                            },
                                            {
                                              "name": 'LY Sales',
                                              "columnName": 'LYSales(Value)',
                                              "width": '135px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true
                                            },
                                            {
                                              "name": 'Growth %',
                                              "columnName": 'Growth(Value)',
                                              "width": '135px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": false,
                                              "percent": true
                                            }
                                          ],
                                          "title": 'CustomerName',
                                          "endpoint": "T19.2",
                                          "parameters": [
                                            { "key": "FromMonth", "value": "2024" },
                                            { "key": "FromYear", "value": "1" },
                                            { "key": "ToMonth", "value": "2024" },
                                            { "key": "ToYear", "value": "1" },
                                            { "key": "AgentCode", "value": "" },
                                            { "key": "CustomerGroupDistributorCode", "value": "" },
                                            { "key": "ConfigTypeCode", "value": "" }
                                          ]
                                        },
                                        "context": {
                                          "point": {
                                            "onClick": {
                                              "selectedValueColumn": "CustomerGroupDistributorCodeCustomerCode",
                                              "selectedTitle": "Product",
                                              "visual": [
                                                {
                                                  "columns": 12,
                                                  "rows": 2,
                                                  "visual": {
                                                    "id": 1,
                                                    "type": "advancedTable",
                                                    "colorTheme": "colorTheme1",
                                                    "title": "Product",
                                                    "binding": {
                                                      "data": {
                                                        "columns": [
                                                          {
                                                            "name": 'Product Name',
                                                            "columnName": 'ItemName',
                                                            "width": '180px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                          },
                                                          {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                          },
                                                          {
                                                            "name": 'LY Sales',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '135px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                          },
                                                          {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '135px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                          }
                                                        ],
                                                        "title": 'ItemName',
                                                        "endpoint": "T19.3",
                                                        "parameters": [
                                                          { "key": "FromMonth", "value": "2024" },
                                                          { "key": "FromYear", "value": "1" },
                                                          { "key": "ToMonth", "value": "2024" },
                                                          { "key": "ToYear", "value": "1" },
                                                          { "key": "AgentCode", "value": "" },
                                                          { "key": "CustomerGroupDistributorCodeCustomerCode", "value": "" },
                                                          { "key": "ConfigTypeCode", "value": "" }
                                                        ]
                                                      },
                                                      "context": {
                                                        "point": {
                                                          "onClick": {
  
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "pie",
          "colorTheme": "colorTheme1",
          "title": "Share by Customer Group Sales",
          "binding": {
            "data": {
              "title": 'CustomerGroup',
              "value": 'Share(Value)',
              "tooltip": 'ActualSales(Value)',
              "currency": true,
              "percent": true,
              "endpoint": "T19",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "AgentCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "CustomerGroup",
                  "selectedTitle": "Channel",
                  "visual": [
                    {
                      "columns": 12,
                      "rows": 2,
                      "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": "colorTheme1",
                        "title": "Channel",
                        "binding": {
                          "data": {
                            "columns": [
                              {
                                "name": 'Channel',
                                "columnName": 'DistributorCode',
                                "width": '180px',
                                "align": "left",
                                "sortable": true,
                                "sum": false
                              },
                              {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales(Value)',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true
                              },
                              {
                                "name": 'LY Sales',
                                "columnName": 'LYSales(Value)',
                                "width": '135px',
                                "align": "right",
                                "sortable": true,
                                "sum": true
                              },
                              {
                                "name": 'Growth %',
                                "columnName": 'Growth(Value)',
                                "width": '135px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                              }
                            ],
                            "title": 'DistributorCode',
                            "endpoint": "T19.1",
                            "parameters": [
                              { "key": "FromMonth", "value": "2024" },
                              { "key": "FromYear", "value": "1" },
                              { "key": "ToMonth", "value": "2024" },
                              { "key": "ToYear", "value": "1" },
                              { "key": "AgentCode", "value": "" },
                              { "key": "CustomerGroup", "value": "" },
                              { "key": "ConfigTypeCode", "value": "" }
                            ]
                          },
                          "context": {
                            "point": {
                              "onClick": {
                                "selectedValueColumn": "CustomerGroupDistributorCode",
                                "selectedTitle": "Customer",
                                "visual": [
                                  {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                      "id": 1,
                                      "type": "advancedTable",
                                      "colorTheme": "colorTheme1",
                                      "title": "Customer",
                                      "binding": {
                                        "data": {
                                          "columns": [
                                            {
                                              "name": 'Customer Name',
                                              "columnName": 'CustomerName',
                                              "width": '250px',
                                              "align": "left",
                                              "sortable": true,
                                              "sum": false
                                            },
                                            {
                                              "name": 'Actual Sales',
                                              "columnName": 'ActualSales(Value)',
                                              "width": '140px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true
                                            },
                                            {
                                              "name": 'LY Sales',
                                              "columnName": 'LYSales(Value)',
                                              "width": '135px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true
                                            },
                                            {
                                              "name": 'Growth %',
                                              "columnName": 'Growth(Value)',
                                              "width": '135px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": false,
                                              "percent": true
                                            }
                                          ],
                                          "title": 'CustomerName',
                                          "endpoint": "T19.2",
                                          "parameters": [
                                            { "key": "FromMonth", "value": "2024" },
                                            { "key": "FromYear", "value": "1" },
                                            { "key": "ToMonth", "value": "2024" },
                                            { "key": "ToYear", "value": "1" },
                                            { "key": "AgentCode", "value": "" },
                                            { "key": "CustomerGroupDistributorCode", "value": "" },
                                            { "key": "ConfigTypeCode", "value": "" }
                                          ]
                                        },
                                        "context": {
                                          "point": {
                                            "onClick": {
                                              "selectedValueColumn": "CustomerGroupDistributorCodeCustomerCode",
                                              "selectedTitle": "Product",
                                              "visual": [
                                                {
                                                  "columns": 12,
                                                  "rows": 2,
                                                  "visual": {
                                                    "id": 1,
                                                    "type": "advancedTable",
                                                    "colorTheme": "colorTheme1",
                                                    "title": "Product",
                                                    "binding": {
                                                      "data": {
                                                        "columns": [
                                                          {
                                                            "name": 'Product Name',
                                                            "columnName": 'ItemName',
                                                            "width": '180px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                          },
                                                          {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                          },
                                                          {
                                                            "name": 'LY Sales',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '135px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                          },
                                                          {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '135px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                          }
                                                        ],
                                                        "title": 'ItemName',
                                                        "endpoint": "T19.3",
                                                        "parameters": [
                                                          { "key": "FromMonth", "value": "2024" },
                                                          { "key": "FromYear", "value": "1" },
                                                          { "key": "ToMonth", "value": "2024" },
                                                          { "key": "ToYear", "value": "1" },
                                                          { "key": "AgentCode", "value": "" },
                                                          { "key": "CustomerGroupDistributorCodeCustomerCode", "value": "" },
                                                          { "key": "ConfigTypeCode", "value": "" }
                                                        ]
                                                      },
                                                      "context": {
                                                        "point": {
                                                          "onClick": {
  
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      }
    ]
  }